import "./category.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function CategoryBar({ setCategory }) {

  const [openMenu, setOpenMenu] = useState(null);
  const navigate = useNavigate();

  const openProduct = (item) => {
    setCategory(item);
    navigate(`/?category=${encodeURIComponent(item)}`);
    setOpenMenu(null);
  };

  const menus = [
    {
      name: "Kratom",
      items: [
        "Kratom Powder",
        "Kratom Capsules",
        "Kratom Extract"
      ]
    },
    {
      name: "CBD",
      items: [
        "CBD Gummies",
        "CBD Oils",
        "CBD Flower"
      ]
    },
    {
      name: "THC",
      items: [
        "THC Gummies",
        "THC Vapes",
        "THCA Flower"
      ]
    },
    {
      name: "Delta 9",
      items: [
        "Delta 9 Gummies",
        "Delta 9 Vape",
        "Delta 9 Flower"
      ]
    },
    {
      name: "Smoke Shop",
      items: [
        "Grinders",
        "Pre-Rolls",
        "Vape Pens",
        "Accessories"
      ]
    }
  ];

  return (
    <div className="category-bar">

      {/* ALL */}
      <div
        className="menu-item"
        onClick={() => openProduct("All")}
      >
        All
      </div>

      {/* DROPDOWNS */}
      {menus.map((menu, index) => (
        <div
          className="dropdown"
          key={index}
          onMouseEnter={() => setOpenMenu(index)}
          onMouseLeave={() => setOpenMenu(null)}
        >
          <div className="menu-item">
            {menu.name} ▼
          </div>

          <div className={`dropdown-content ${openMenu === index ? "show" : ""}`}>
            {menu.items.map((item, i) => (
              <div
                key={i}
                className="dropdown-item"
                onClick={() => openProduct(item)}
              >
                {item}
              </div>
            ))}
          </div>
        </div>
      ))}

      {/* SINGLE CATEGORIES (FIXED) */}
      <div className="menu-item" onClick={() => openProduct("Blue Lotus")}>
        Blue Lotus
      </div>

      <div className="menu-item" onClick={() => openProduct("7-Hydroxy")}>
        7-Hydroxy
      </div>

      <div className="coming-soon">
        🚀 Coming Soon
      </div>

    </div>
  );
}